var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticClass:"height-full"},[_c('div',{staticClass:"p-16px"},[_c('layouts-perm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }